import { buttonVariants } from "@/components/ui/button.tsx";
import { m } from "@/paraglide/messages.js";
import { createFileRoute } from "@tanstack/react-router";
import { Lock } from "lucide-react";
import { pageTitle } from "@/utils/page-title.ts";

export const Route = createFileRoute("/_authenticated/settings/org/scim")({
	component: RouteComponent,
	head: () => ({
		meta: [{ title: pageTitle(m.admin_settings_scim_tab()) }],
	}),
});

function RouteComponent() {
	return (
		<div className="flex flex-col items-center justify-center min-h-96 gap-4 text-center">
			<Lock className="h-8 w-8 text-muted-foreground" />
			<h3 className="font-semibold">
				{m.admin_settings_scim_enterprise_required_title()}
			</h3>
			<p className="text-sm text-muted-foreground max-w-sm">
				{m.admin_settings_scim_enterprise_required_description()}
			</p>
			<a
				href="mailto:hello@oneai.eu"
				className={buttonVariants({ variant: "outline" })}
			>
				{m.admin_settings_scim_contact_sales()}
			</a>
		</div>
	);
}
